//window._ = require('lodash');

try {
    window.Popper = require('@popperjs/core');
    window.$ = window.jQuery = require('jquery');
    require('jquery-validation/dist/jquery.validate');
    require('jquery-ui/dist/jquery-ui');
    window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle');
    window.masonry = require('masonry-layout/dist/masonry.pkgd.min');
    window.imagesLoaded = require('imagesloaded/imagesloaded.pkgd.min');
    window.lazy = require('jquery-lazy');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
